<template>
  <ExternalQueryList
      endpoint="/api/v2/publications"
      :headlines="headlines"
      :filters="filters"
      :can-destroy="() => true"
      :can-update="() => true"
      @show="publication => $router.push(getUrl(publication))"
  >
    <template v-slot:default="{ row: publication }">
      <td>
        <router-link :to="getUrl(publication)">
          {{ publication.attributes.name }}
        </router-link>
      </td>

      <td>
        {{ publication.attributes.publication_channel_name }} ({{ publication.attributes.portal_name }})
      </td>

      <td>
        {{ publication.attributes.publish_at | date }}
      </td>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'

export default {
  components: {ExternalQueryList},

  props: {
    portals: {
      required: true
    },

    publicationChannels: {
      required: true
    }
  },

  computed: {
    headlines() {
      return [
        {width: 8, text: 'Name'},
        {width: 8, text: 'Channel'},
        {width: 6, text: 'Publish At'}
      ]
    },

    filters() {
      return [
        [
          {
            width: 6,
            widget: 'select',
            name: 'portal_id',
            options: this.portals.map(portal => ({value: portal.id, label: portal.attributes.name})),
            nullable: true,
            placeholder: 'Choose Portal...'
          },
          {
            width: 6,
            widget: 'select',
            name: 'publication_channel_id',
            options: this.publicationChannels.map(publicationChannel => ({value: publicationChannel.id, label: publicationChannel.attributes.name})),
            nullable: true,
            placeholder: 'Choose Publication Channel...'
          },
          {
            width: 4,
            widget: 'date',
            name: 'publish_from',
            nullable: true,
            placeholder: 'Publish From...'
          },
          {
            width: 4,
            widget: 'date',
            name: 'publish_to',
            nullable: true,
            placeholder: 'Publish To...'
          },
          {
            width: 4,
            widget: 'submit'
          }
        ]
      ]
    }
  },

  methods: {
    getUrl(publication) {
      return '/publications/' + publication.id
    }
  }
}
</script>
